// extracted by mini-css-extract-plugin
export default {"search":"Search_search__QZXMV","input":"Search_input__ZNCMy","close":"Search_close__6lf+l"};